const GRAPHQL_ENDPOINT = '/graphql/words';

/**
 * Service to interact with Drupal GraphQL
 */
export async function graphqlQuery(query, variables = {}) {
    // Check if graphqlQuery is available globally (provided by Drupal)
    if (typeof window.graphqlQuery === 'function') {
        return await window.graphqlQuery(query, variables);
    }

    const timestamp = Date.now();
    const url = `${GRAPHQL_ENDPOINT}?t=${timestamp}`;

    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ query, variables }),
    });
    const result = await response.json();
    if (result.errors) {
        console.error('GraphQL errors:', result.errors);
        console.error('Query:', query);
        console.error('Variables:', variables);
        throw new Error(result.errors[0].message);
    }
    return result.data;
}

/**
 * Get current Drupal user information
 */
export function getCurrentUser() {
  if (window.drupalSettings && window.drupalSettings.currentuser) {
      return window.drupalSettings.currentuser;
  }
  return null;
}

/**
 * Check if user is logged in
 */
export function isUserLoggedIn() {
  const user = getCurrentUser();
  return user && user.uid && user.uid !== 0;
}
